<p-toast></p-toast>
<div class="app-mi-source-location">
    <div class="block md:hidden">
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                    <!-- <mat-icon>menu</mat-icon> -->
                </div>
                <div class="header">
                    <p>{{'WELOCOME_TO'| translate}}</p>
                    <p>{{'MICADA_MOBILE_APPLICATION'| translate}}</p>
                </div>
                <div class="subheader">
                    <p> {{'EFFICIENT_AND_ELEGANT_WAY_TO_VERIFY_SITE'| translate}}</p>
                </div>
            </div>
        </div>
        <div style="padding: 0 1em;">
            <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of micada1Data"
                (click)="onRowSelect(item)">
                <!-- <table cellspacing="1"> -->
                <table cellspacing="10">
                    <tr>
                        <td class="fontXl"><b>{{'APP_ID'| translate}}</b></td>
                        <td class="fontXl">
                            {{item.app_id}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'PROGRAMME_NAME'| translate}}</b></td>
                        <td>
                            {{item.programmename}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'NAME'| translate}}</b></td>
                        <td>
                            {{item.name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FATHER_NAME'| translate}}</b></td>
                        <td>
                            {{item.father_name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'MOTHER_NAME'| translate}}</b></td>
                        <td>
                            {{item.mother_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'DISTICT'| translate}}</b></td>
                        <td>
                            {{item.distict}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'BLOCK'| translate}}</b></td>
                        <td>
                            {{item.block}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VILLAGE'| translate}}</b></td>
                        <td>
                            {{item.village}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'GPS_COORDINATES'| translate}}</b></td>
                        <td>
                            {{item.gpsCoordinate}}
                        </td>
                    </tr>
                </table>
            </p-card>
        </div>
    </div>

    <!-- Hidden on small screens -->
    <div class="hidden md:block">
        <p-card styleClass="p-card-shadow">
            <div class="card dashboardTable">
                <p-table #miSourceLocationTable [value]="micada1Data" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['app_id', 'programmename', 'name', 'father_name', 'mother_Name', 'distict', 'block', 'village', 'gpsCoordinate']"
                    responsiveLayout="scroll" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                    [showCurrentPageReport]="true">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'MI_PHYSICAL_LOCATION'| translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input style="width: 100% ;" pInputText type="text"
                                    (input)="miSourceLocationTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" class="tableHeader">
                        <tr>
                            <th pSortableColumn="app_id">{{'APP_ID'| translate}}
                                <p-columnFilter type="text" field="app_id" display="menu"></p-columnFilter>
                                <p-sortIcon field="app_id"></p-sortIcon>
                            </th>
                            <th pSortableColumn="programmename">{{'PROGRAMME_NAME'| translate}}
                                <p-columnFilter type="text" field="programmename" display="menu"></p-columnFilter>
                                <p-sortIcon field="programmename"></p-sortIcon>
                            </th>
                            <th pSortableColumn="name">{{'NAME'| translate}}
                                <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                                <p-sortIcon field="name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="father_name">{{'FATHER_NAME'| translate}}
                                <p-columnFilter type="text" field="father_name" display="menu"></p-columnFilter>
                                <p-sortIcon field="father_name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="mother_Name">{{'MOTHER_NAME'| translate}}
                                <p-columnFilter type="text" field="mother_Name" display="menu"></p-columnFilter>
                                <p-sortIcon field="mother_Name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="distict">{{'DISTRICT'| translate}}
                                <p-columnFilter type="text" field="distict" display="menu"></p-columnFilter>
                                <p-sortIcon field="distict"></p-sortIcon>
                            </th>
                            <th pSortableColumn="block">{{'BLOCK'| translate}}
                                <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                                <p-sortIcon field="block"></p-sortIcon>
                            </th>
                            <th pSortableColumn="village">{{'VILLAGE'| translate}}
                                <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                                <p-sortIcon field="village"></p-sortIcon>
                            </th>
                            <th pSortableColumn="gpsCoordinate">{{'GPS_COORDINATES'| translate}}
                                <p-columnFilter type="text" field="gpsCoordinate" display="menu"></p-columnFilter>
                                <p-sortIcon field="gpsCoordinate"></p-sortIcon>
                            </th>

                            <th pSortableColumn="">{{'ACTION'| translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>

                            <td>{{product.app_id}}</td>
                            <td>{{product.programmename}}</td>
                            <td>{{product.name}}</td>
                            <td>{{product.father_name}}</td>
                            <td>{{product.mother_Name}}</td>
                            <td>{{product.distict}}</td>
                            <td>{{product.block}}</td>
                            <td>{{product.village}}</td>
                            <td>{{product.gpsCoordinate}}</td>

                            <td>
                                <button pButton pRipple type="button" pTooltip="Add-Location" icon="pi pi-plus"
                                    class="p-button-rounded p-button-text" (click)='onRowSelect(product)'></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate}} {{micada1Data ? micada1Data.length : 0 }}
                            {{'VER_APP_ADDED'|
                            translate}}
                        </div><br>
                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>


<p-dialog header="{{'GEO_LOCATION_(MICADA_1.0)'| translate}}" [(visible)]="displaySourceLocationDialog" [modal]="true"
    [style]="{width: '90%',height:'90%'}" [maximizable]="true" [draggable]="false" [resizable]="false"
    (onHide)="onCloseDialog()">

    <!-- Content Start-->
    <div class="card dropdown-content" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid">

            <div class="field col-12 md:col-2">
                <label htmlFor="app_id">{{'APP_ID'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.app_id}}</label>
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="programmename">{{'PROGRAMME_NAME'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.programmename}}</label>
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="name">{{'NAME'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.name}}</label>
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="fatherName">{{'FATHER_NAME'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.father_name}}</label>
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="fatherName">{{'MOTHER_NAME'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.mother_Name}}</label>
                </div>
            </div>
        </div>
    </div>
    <div class="card dropdown-content" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid">

            <div class="field col-6 md:col-3" *ngIf="rowData?.JERemarks">
                <label htmlFor="je_remarks">{{'JE_REMARKS'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.JERemarks}}</label>
                </div>
            </div>

            <div class="field col-6 md:col-3" *ngIf="rowData?.XENRemarks">
                <label htmlFor="xen_remarks">{{'XEN_REMARKS'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.XENRemarks}}</label>
                </div>
            </div>

            <div class="field col-6 md:col-3" *ngIf="rowData?.DDAssociateRemarks">
                <label htmlFor="da_remarks">{{'DD_ASSOCIATE_REMARKS'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.DDAssociateRemarks}}</label>
                </div>
            </div>

            <div class="field col-6 md:col-3" *ngIf="rowData?.DMICADARemarks">
                <label htmlFor="dimicada_remarks">{{'DIMICADA_REMARKS'| translate}}</label>
                <div class="grid-item">
                    <label [style]="{color: 'rgb(168, 32, 32)'}">{{ rowData?.DMICADARemarks}}</label>
                </div>
            </div>
        </div>
    </div>


    <div class="card mapdashboard" style="margin: 5px;">
        <div class="grid justify-content-center m-2">

        </div>

        <div class="card p-fluid p-formgrid grid">
            <!-- <div class="field col-12 md:col-3">
                <button (click)="captureLocation()" pButton pRipple type="submit"
                    label="{{'CAPTURE_LOCATION'| translate}}" class="p-button-success mr-2 mb-2"
                    *ngIf="!showgeoLocation"></button>
                <button (click)="captureLocation()" pButton pRipple type="submit"
                    label="{{'REFRESH_LOCATION'| translate}}" class="p-button-success mr-2 mb-2"
                    *ngIf="showgeoLocation"></button>
            </div> -->

            <div class="field col-0 md:col-4"></div>

            <div class="field col-6 md:col-2" *ngIf="showgeoLocation">
                <label htmlFor="latitude">{{'LATITUDE'| translate}}</label>
                <div class="grid-item">
                    <input readonly [(ngModel)]="latPosition" pInputText type="number" />
                </div>
            </div>

            <div class="field col-6 md:col-2" *ngIf="showgeoLocation">
                <label htmlFor="longitude">{{'LONGITUDE'| translate}}</label>
                <div class="grid-item">
                    <input readonly [(ngModel)]="longPosition" pInputText type="number" />
                </div>
            </div>
        </div>
        <div class="p-fluid p-formgrid grid" *ngIf='showMap'>
            <div class="field col-12 md:col-12">
                <p-gmap [options]="options" [overlays]="overlays" [style]="{'width':'100%','height':'320px'}"></p-gmap>
            </div>
        </div>
    </div>

    <div class="card actionStatus" style="margin: 5px;" *ngIf='showMap'>
        <div class="p-fluid p-formgrid grid justify-content-around">

            <div class="field col-6 md:col-3">
                <div class="grid-item">
                    <input readonly [(ngModel)]="selectedStatus" pInputText type="text" />
                </div>
            </div>
            <div class="field col-6 md:col-4">
                <textarea id="description" [(ngModel)]="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea
                    required rows="3" cols="20" class="mr-3"></textarea>
            </div>
            <div class="field col-6 md:col-2">
                <button pButton pRipple label="{{'SUBMIT'| translate}}" (click)="submitFinalData()"
                    class="p-button-help"></button>
            </div>
        </div>
    </div>
    <!-- Content End-->
</p-dialog>